import { memo } from 'react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { Trend } from '@root/entities/trend'
import { TrendTriangle } from '@root/entities/trend/ui'
import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'

import type { ClassNameProps } from '@root/shared/react'
import type { BigNumber } from 'bignumber.js'

type Props = {
  percents: BigNumber
  iconSize?: number
} & ClassNameProps

export const PercentChange: React.FC<Props> = memo(
  ({ percents, className, iconSize = 12 }) => {
    if (percents.isZero() || !percents.isFinite()) {
      return <span />
    }

    const trend = Trend.of(percents)

    return (
      <Percent data-trend={trend} className={className}>
        <TrendTriangle trend={trend} size={iconSize} />
        <FlashTextContentDistinct>
          <Numeric value={percents.abs()} preset="trend-change-percents" />%
        </FlashTextContentDistinct>
      </Percent>
    )
  },
)

const Percent = styled.span`
  &[data-trend='down'] {
    color: var(--down-9);
  }

  &[data-trend='up'] {
    color: var(--up-9);
  }

  display: grid;
  grid-template-columns: auto auto;
  align-items: center;

  font-size: 12px;
  font-weight: 500;
  line-height: normal;
`
